/**
 * Identidad de la aplicación. ÚNICA fuente del nombre en todo el proyecto.
 *
 * Vive fuera de src/ a propósito: lo leen tanto la aplicación como `vite.config.ts`
 * (para el manifest de la PWA y el <title>), y vite.config se ejecuta en Node, donde
 * `import.meta.env` no existe. Este archivo no importa nada, así que sirve a los dos.
 *
 * "RugbyPronos" es PROVISIONAL. Cuando haya nombre definitivo se cambia aquí y ya:
 * ni un componente, ni un texto de traducción, ni el manifest lo repiten.
 */
export const APP_NAME = 'RugbyPronos';

/** Nombre para el icono de la pantalla de inicio. Corto o el sistema lo recorta. */
export const APP_SHORT_NAME = 'RugbyPronos';

export const APP_DESCRIPTION =
  'Pronostics de rugby entre amis : Top 14 et Champions Cup. Sans argent réel.';

/** Colores del manifest y de la barra del sistema en modo instalado. */
export const THEME_COLOR = '#0f2e1d';
export const BACKGROUND_COLOR = '#0b1f14';
